module.exports = __webpack_public_path__ + "static/media/irritated-annoyed.2ab10e65.png";